const PropertyTypeActions = {
    CLEAR_ADDITIONAL_PROPERTY_TYPE: 'CLEAR_ADDITIONAL_PROPERTY_TYPE',
    SET_ADDITIONAL_PROPERTY_TYPE: 'SET_ADDITIONAL_PROPERTY_TYPE',

    clearAdditionalPropertyType: () => ({
        type: PropertyTypeActions.CLEAR_ADDITIONAL_PROPERTY_TYPE
    }),

    setAdditionalPropertyType: (propertyType) => ({
        type: PropertyTypeActions.SET_ADDITIONAL_PROPERTY_TYPE,
        propertyType
    })
};

export default PropertyTypeActions;
